/**
 * External dependencies
 */
import type { ReactNode } from 'react';

export type StyleProviderProps = {
	/**
	 * The children elements.
	 */
	children: ReactNode;
	/**
	 * Current document.
	 */
	document: Document;
};
